import { ToastrService } from 'ngx-toastr';
import { MatSnackBar as MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { QuotationRequestService } from '@app/_services/quotation-request.service';
import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { FlexModule } from '@angular/flex-layout/flex';
import { NgIf, NgFor } from '@angular/common';


@Component({
    selector: 'app-page-quotation-request-details',
    templateUrl: './page-quotation-request-details.component.html',
    styleUrls: ['./page-quotation-request-details.component.scss'],
    standalone: true,
    imports: [NgIf, FlexModule, ExtendedModule, RouterLink, MatDividerModule, NgFor, MatIconModule, TranslateModule]
})
export class PageQuotationRequestDetailsComponent implements OnInit {

  constructor(private quotationRequestService: QuotationRequestService, private activeRoute: ActivatedRoute,
    private toast: ToastrService) { }

  id;
  request;
  loading;

  imageTypes: Array<string> = [
    'image/gif',
    'image/jpeg',
    'image/png'
];

  ngOnInit(): void {
    this.activeRoute.params.subscribe((result) => {
        this.id=result.slug
    });
    this.loading = true;
    this.quotationRequestService.getRequest(this.id).subscribe((response)=>{
        if (response.code == 200) {
            this.request = response.data;
            this.loading = false;
        } else {
            this.toast.error("Error Loading Request Data");
            this.loading = false;
        }
    },(error)=>{
        this.toast.error("Error Loading Request Data");
        this.loading = false;
    });
  }

  status = {
    new: {
        color: '#125077',
        text: 'New',
    },
    open: {
        color: '#9E6DEB',
        text: 'Open',
    },
    offered: {
        color: '#ff5900',
        text: 'Offered',
    },
    accepted: {
        color: '#079008',
        text: 'Accepted',
    },
    inprogress: {
        color: '#6D9EEB',
        text: 'In-Progress',
    },
    rejected: {
        color: '#ff0202',
        text: 'Rejected',
    },

    cancelled: {
        color: '#ff0202',
        text: 'Cancelled',
    },
    renegotiated: {
        color: '#0095a0',
        text: 'Renegotiated',
    },
};

isFileImage(mimeType: string) {
    return this.imageTypes.includes(mimeType);
}

}
